import axios from "axios";
import { getUserDetails } from "./utils/shared-data.service";

export const apiPaths = {
  questionbyid: "questionbyid",
  subjects: "admin/subjects",
  tags: "admin/tags",
  topics: "admin/topics",
  dashboardGraph: "dashboardgraph",
  qbStats: "qbStats",
  getQuestionFeedbackById: "getQuestionFeedbackById",
  // serverUrl:
  uploadQuestions: "uploadQuestions",
  questionslist: "questionslist",
  searchQB: "searchQB",
  getQuestionHistory: "getQuestionHistory",
  questionslistByStatus: "questionslistbystatus",
  question: "question",
  courses: "admin/courses",
  examsList: "examsInfo",
  questionsListByExam: "getQuestionsByExamId",
  getFeedbackForQuestions: "getFeedbackForQuestions",
  questionBankQuestions: "allQuestions",
  updateQuestionFeedbackStatus: "updateQuestionFeedbackStatus",
  getQuestionsForExam: "getQuestionsForExam",
  getQuestionsByExamId: "getQuestionsByExamId",
  saveExam: "saveExam",
  pushToApp: "pushToApp",
  copyExam: "copyExam",
  batches: "admin/batches",
  branches: "admin/branches",
  delete: "questions/delete",
  deleteExam: "delete",
  updateQuestionStatus: "questions/updateStatus",
  login: "usermanagement/login",
  logout: "usermanagement/logout",
  count: "/count",
  questionstatusaudit: "questionstatusaudit",
  savecomments: "savecomments",
  questionsUpdateStatus: "questions/updateStatus",
  downloadMedia: "downloadMediaFiles",
  downloadExamPaper: "downloadExamPaper",
  downloadQB: "admin/downloadLibraryQBQuestionPaper",
  downloadTest: "admin/downloadLibraryTestQuestionPaper",
  uploadMedia: "uploadMediaFiles",
  updateExamActiveStatus: "updateExamActiveStatus",
  updateExamStatus: "updateExamStatus",
  roles: "usermanagement/roles",
  deleteRole: "/admin/usermanagement/deleteRole",
  acadRoles: "admin/usermanagement/roles/ACAD_PORTAL",
  acadSaveRole: "admin/usermanagement/saveRole/ACAD_PORTAL",
  acadDeleteUserBranchPermission: "/admin/usermanagement/deleteUserBranchPermission/ACAD_PORTAL",
  acadUserBranchPermission: "/admin/usermanagement/getUserBranchPermissions/ACAD_PORTAL",
  saveUserBranchPermission: "/admin/usermanagement/saveUserBranchPermissions",
  listUserSubjectMap: "usermanagement/listUserSubjectMap",
  deleteUserFromSubject: "usermanagement/deleteUserFromSubject",
  MapUserToSubject: "usermanagement/MapUserToSubject",
  usersList: "usermanagement/usersList",
  acadUserList: "admin/usermanagement/usersList/ACAD_PORTAL",
  deleteUser: "usermanagement/deleteUser",
  saveUser: "usermanagement/saveUser",
  acadSaveUser: "admin/usermanagement/saveUser/ACAD_PORTAL",
  examstakenbyuser: "/getexamstakenbyuser",
  updateuserexamstatus: "/updateUserExamStatus",
  forgotPassword: "usermanagement/forgotPassword",
  changePassword: "usermanagement/changePassword",
  getCompletedLiveClasses: "faculty/getCompletedLiveClasses",
  getLiveClasses: "faculty/getLiveClasses",
  getLiveClassesById: "faculty/getLiveClassById",
  updateLiveClassStatus: "faculty/updateLiveClassStatus",
  getZoomSignature: "zoom/getZoomSignature",
  getLibraryQB: "admin/getLibraryQB",
  getQuestionIdsByQB: "admin/getQuestionIdsByQB",
  getQuestionIdsByTest: "admin/getQuestionIdsByTest",
  getLibraryTests: "admin/getLibraryTests",
  getTenants: "admin/auth/getTenants",
  sendQuestionFeedbackMail: "sendQuestionFeedbackMail",
  deleteQuestion: "questions/delete",
  questionByText: "questionbytext",
  deleteQuestionFromQB: "admin/deleteQuestionFromQB",
  addQuestionToQB: "admin/addQuestionToQB",
  addQuestionToTest: "/admin/addQuestionToTest",
  deleteQuestionFromTest: "/admin/deleteQuestionFromTest"

};

export const get = async (url, queryparams, headers, responseType = "json") => {
  // '/'
  let res = await axios.get(process.env.REACT_APP_API_PATH + url, {
    params: queryparams,
    headers: headers || { userEmail: getUserDetails().email },
    responseType,
  });
  return res?.data;
};
export const getInstutueApp = async (url, queryparams, headers, responseType = "json") => {
  // '/'
  let res = await axios.get(process.env.REACT_APP_BASE2_PATH + url, {
    params: queryparams,
    headers: headers || { userEmail: getUserDetails().email },
    responseType,
  });
  
  // If blob, return whole response (need headers + data)
  if (responseType === "blob") {
    return res;
  }

  return res?.data;
};
export const postInstituteAppData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.post(
      process.env.REACT_APP_BASE2_PATH + url,
      //'https://devapi.arisemedicalacademy.com/instituteApp/'+url,
      data.data,
      {
        params: data.params,
        headers: data.headers || { userEmail: getUserDetails().email },
      }
    );
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};
export const deleteInstituteAppData = async (url = "", data = {}) => {
  try {
    const response = await axios.delete(process.env.REACT_APP_BASE2_PATH + url, {
      data: data.body,  // Use 'body' for request payload
      params: data.params,
      headers: {
        ...data.headers,
        userEmail: getUserDetails().email  // Ensure userEmail is always included
      }
    });
    return response?.data;
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available. Please try after some time"
    );
  }
};

export const postData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.post(
      process.env.REACT_APP_API_PATH + url,
      data.data,
      {
        params: data.params,
        headers: data.headers || { userEmail: getUserDetails().email },
      }
    );
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const deleteData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.delete(process.env.REACT_APP_API_PATH + url, {
      data: data.data,
      params: data.params,
      headers: data.headers || { userEmail: getUserDetails().email },
    });
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const getData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.get(process.env.REACT_APP_API_PATH + url, {
      params: data.params,
      headers: data.headers || { userEmail: getUserDetails().email },
    });
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const getAdminData = async (url = "", data = {}) => {
  console.log('url: ', url);
  console.log('process.env.REACT_APP_BASE2_PATH: ', process.env.REACT_APP_BASE2_PATH);
  try {
    // Default options are marked with *
    let response = await axios.get(process.env.REACT_APP_BASE2_PATH + url, {
      params: data.params,
      headers: data.headers || { userEmail: getUserDetails().email },
    });
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const getBase2 = async (
  url,
  queryparams,
  headers,
  responseType = "json"
) => {
  // '/'
  let res = await axios.get(process.env.REACT_APP_API_PATH + url, {
    params: queryparams,
    headers: headers || { userEmail: getUserDetails().email },
    responseType,
  });
  return res?.data;
};

export const patch = async (
  url,
  queryparams,
  headers,
  responseType = "json"
) => {
  try {
    let res = await axios.patch(process.env.REACT_APP_API_PATH + url, {
      params: queryparams,
      headers: headers || { userEmail: getUserDetails().email },
      responseType,
    });
    return res?.data;
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};
